import React, { useState } from "react";
import TelegramBot from "./TelegramBot";
import GoogleCalendar from "./GoogleCalendar";
import WhatsAppReminders from "./WhatsAppReminders";
import "../style/css/TelegramBot.css";

// Tab Icons (color #0D6EFD)
const TelegramTabIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#0D6EFD">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.57-1.38-.93-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69.01-.03.01-.14-.06-.2-.07-.06-.17-.04-.24-.02-.1.02-1.79 1.14-5.06 3.34-.48.33-.91.49-1.3.48-.43-.01-1.26-.24-1.88-.44-.76-.24-1.36-.37-1.31-.78.03-.26.32-.53.88-.81 3.47-1.51 5.78-2.51 6.94-3.01 3.05-1.32 3.68-1.55 4.1-1.56.09 0 .3.02.43.14.11.1.14.23.16.43.02.2.03.66.01 1.08z" />
  </svg>
);

const GoogleTabIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#0D6EFD">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
  </svg>
);

const WhatsAppTabIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#0D6EFD">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
  </svg>
);

const NotificationSettings: React.FC = () => {
  const [activeTab, setActiveTab] = useState<
    "telegram" | "google" | "whatsapp"
  >("telegram");

  const tabs = [
    { id: "telegram", label: "Telegram", Icon: TelegramTabIcon },
    { id: "google", label: "Google Calendar", Icon: GoogleTabIcon },
    { id: "whatsapp", label: "WhatsApp", Icon: WhatsAppTabIcon },
  ] as const;

  const renderActiveComponent = () => {
    switch (activeTab) {
      case "telegram":
        return <TelegramBot />;
      case "google":
        return <GoogleCalendar />;
      case "whatsapp":
        return <WhatsAppReminders />;
    }
  };

  return (
    <div className="notification-settings-container">
      <div className="settings-header-large">
        <h1>Configuración de Notificaciones</h1>
        <p>Conecta y configura tus servicios de notificaciones</p>
      </div>

      <div className="tabs-container">
        <div className="tabs-wrapper">
          {tabs.map((tab) => {
            const Icon = tab.Icon;
            return (
              <button
                key={tab.id}
                className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => setActiveTab(tab.id as any)}
              >
                <Icon />
                <span className="tab-label">{tab.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      <div className="tab-content">{renderActiveComponent()}</div>
    </div>
  );
};

export default NotificationSettings;
